import React from "react";
import Footer from "../footer/footer";
import "./Ho.css";
// import "./nicepage.css";
function Team() {
  return (
    <div class="u-body u-xl-mode" style={{backgroundImage: 'url("pattern-bg.jpg")'}}>
      <section
        class="u-align-center u-clearfix u-grey-5 u-section-1"
        id="carousel_2f37"
      >
        <div class="u-clearfix u-sheet u-valign-middle u-sheet-1">
          <h2 class="u-text u-text-default u-text-1">Meet The Team</h2>
          <p class="u-text u-text-2">
            {" "}
            "None of us, including me, ever do great things. But we can all do
            small things, with great love, and together we can do something
            wonderful."
          </p>
          <div class="u-expanded-width u-list u-list-1">
            <div class="u-repeater u-repeater-1">
              <div class="u-align-left u-container-list-item u-radius-20 u-repeater-item u-shape-round u-white u-list-item-1">
                <div class="u-container-layout u-similar-container u-container-layout-1">
                  <img
                    alt=""
                    class="u-expanded-width u-image u-image-round u-radius-20 u-image-1"
                    data-image-width="864"
                    data-image-height="1152"
                    src="images/dhv.jpg"
                  />
                  <p class="u-text u-text-grey-30 u-text-3">
                    FRONT-END Web developer
                  </p>
                  <h3 class="u-text u-text-default u-text-4">DHARMESH VALA</h3>
                  <p class="u-text u-text-body-color u-text-5">
                    &nbsp;He has expertise in MERN Stack in web development. He
                    is overall handling scholars and doing front-end web
                    development work.
                  </p>
                  <div class="u-align-left u-social-icons u-spacing-30 u-social-icons-1">
                    <a
                      class="u-social-url"
                      target="_blank"
                      data-type="LinkedIn"
                      title="LinkedIn"
                      href="https://www.linkedin.com/in/dharmesh-vala-252724204/"
                    >
                      <span class="u-icon u-social-icon u-social-linkedin u-text-black u-icon-1">
                        <svg
                          class="u-svg-link"
                          preserveAspectRatio="xMidYMin slice"
                          viewBox="0 0 112 112"
                        >
                          <use
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xlinkHref="#svg-fa50"
                          ></use>
                        </svg>
                        <svg
                          class="u-svg-content"
                          viewBox="0 0 112 112"
                          x="0"
                          y="0"
                          id="svg-fa50"
                        >
                          <circle
                            fill="currentColor"
                            cx="56.1"
                            cy="56.1"
                            r="55"
                          ></circle>
                          <path
                            fill="#FFFFFF"
                            d="M41.3,83.7H27.9V43.4h13.4V83.7z M34.6,37.9L34.6,37.9c-4.6,0-7.5-3.1-7.5-7c0-4,3-7,7.6-7s7.4,3,7.5,7
          C42.2,34.8,39.2,37.9,34.6,37.9z M89.6,83.7H76.2V62.2c0-5.4-1.9-9.1-6.8-9.1c-3.7,0-5.9,2.5-6.9,4.9c-0.4,0.9-0.4,2.1-0.4,3.3v22.5
          H48.7c0,0,0.2-36.5,0-40.3h13.4v5.7c1.8-2.7,5-6.7,12.1-6.7c8.8,0,15.4,5.8,15.4,18.1V83.7z"
                          ></path>
                        </svg>
                      </span>
                    </a>
                    <a
                      class="u-social-url"
                      title="twitter"
                      target="_blank"
                      href="https://twitter.com/name"
                    >
                      <span class="u-icon u-icon-circle u-social-icon u-social-twitter u-text-black">
                        <svg
                          class="u-svg-link"
                          preserveAspectRatio="xMidYMin slice"
                          viewBox="0 0 112 112"
                        >
                          <use
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xlinkHref="#svg-030e"
                          ></use>
                        </svg>
                        <svg
                          class="u-svg-content"
                          viewBox="0 0 112 112"
                          x="0"
                          y="0"
                          id="svg-030e"
                        >
                          <circle
                            fill="currentColor"
                            class="st0"
                            cx="56.1"
                            cy="56.1"
                            r="55"
                          ></circle>
                          <path
                            fill="#FFFFFF"
                            d="M83.8,47.3c0,0.6,0,1.2,0,1.7c0,17.7-13.5,38.2-38.2,38.2C38,87.2,31,85,25,81.2c1,0.1,2.1,0.2,3.2,0.2
c6.3,0,12.1-2.1,16.7-5.7c-5.9-0.1-10.8-4-12.5-9.3c0.8,0.2,1.7,0.2,2.5,0.2c1.2,0,2.4-0.2,3.5-0.5c-6.1-1.2-10.8-6.7-10.8-13.1
c0-0.1,0-0.1,0-0.2c1.8,1,3.9,1.6,6.1,1.7c-3.6-2.4-6-6.5-6-11.2c0-2.5,0.7-4.8,1.8-6.7c6.6,8.1,16.5,13.5,27.6,14
c-0.2-1-0.3-2-0.3-3.1c0-7.4,6-13.4,13.4-13.4c3.9,0,7.3,1.6,9.8,4.2c3.1-0.6,5.9-1.7,8.5-3.3c-1,3.1-3.1,5.8-5.9,7.4
c2.7-0.3,5.3-1,7.7-2.1C88.7,43,86.4,45.4,83.8,47.3z"
                          ></path>
                        </svg>
                      </span>
                    </a>
                    <a
                      class="u-social-url"
                      target="_blank"
                      data-type="Github"
                      title="Github"
                      href="https://github.com/Dharmesh177"
                    >
                      <span class="u-icon u-social-github u-social-icon u-text-black u-icon-3">
                        <svg
                          class="u-svg-link"
                          preserveAspectRatio="xMidYMin slice"
                          viewBox="0 0 112 112"
                        >
                          <use
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xlinkHref="#svg-f041"
                          ></use>
                        </svg>
                        <svg
                          class="u-svg-content"
                          viewBox="0 0 112 112"
                          x="0"
                          y="0"
                          id="svg-f041"
                        >
                          <circle
                            fill="currentColor"
                            cx="56.1"
                            cy="56.1"
                            r="55"
                          ></circle>
                          <path
                            fill="#FFFFFF"
                            d="M88,51.3c0-5.5-1.9-10.2-5.3-13.7c0.6-1.3,2.3-6.5-0.5-13.5c0,0-4.2-1.4-14,5.3c-4.1-1.1-8.4-1.7-12.7-1.8
  c-4.3,0-8.7,0.6-12.7,1.8c-9.7-6.6-14-5.3-14-5.3c-2.8,7-1,12.2-0.5,13.5C25,41.2,23,45.7,23,51.3c0,19.6,11.9,23.9,23.3,25.2
  c-1.5,1.3-2.8,3.5-3.2,6.8c-3,1.3-10.2,3.6-14.9-4.3c0,0-2.7-4.9-7.8-5.3c0,0-5-0.1-0.4,3.1c0,0,3.3,1.6,5.6,7.5c0,0,3,9.1,17.2,6
  c0,4.3,0.1,8.3,0.1,9.5h25.2c0-1.7,0.1-7.2,0.1-14c0-4.7-1.7-7.9-3.4-9.4C76,75.2,88,70.9,88,51.3z"
                          ></path>
                        </svg>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              
              <div class="u-align-left u-container-list-item u-radius-20 u-repeater-item u-shape-round u-white">
                <div class="u-container-layout u-similar-container u-container-layout-3">
                  <img
                    alt=""
                    class="u-expanded-width u-image u-image-round u-radius-20 u-image-3"
                    data-image-width="640"
                    data-image-height="640"
                    src="images/tejas.jpg"
                  />
                  <p class="u-text u-text-grey-30 u-text-9">
                    BACK-END DEVELOPER
                  </p>
                  <h3 class="u-text u-text-default u-text-10">TEJAS TANK</h3>
                  <p class="u-text u-text-body-color u-text-11">
                    Tejas is highly experienced in MERN stack and specially in
                    backend development. He is co-ordinate all backend work at
                    scholars.
                  </p>
                  <div class="u-align-left u-social-icons u-spacing-30 u-social-icons-3">
                    <a
                      class="u-social-url"
                      target="_blank"
                      data-type="LinkedIn"
                      title="LinkedIn"
                      href=""
                    >
                      <span class="u-icon u-social-icon u-social-linkedin u-text-black u-icon-7">
                        <svg
                          class="u-svg-link"
                          preserveAspectRatio="xMidYMin slice"
                          viewBox="0 0 112 112"
                        >
                          <use
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xlinkHref="#svg-fa50"
                          ></use>
                        </svg>
                        <svg
                          class="u-svg-content"
                          viewBox="0 0 112 112"
                          x="0"
                          y="0"
                          id="svg-fa50"
                        >
                          <circle
                            fill="currentColor"
                            cx="56.1"
                            cy="56.1"
                            r="55"
                          ></circle>
                          <path
                            fill="#FFFFFF"
                            d="M41.3,83.7H27.9V43.4h13.4V83.7z M34.6,37.9L34.6,37.9c-4.6,0-7.5-3.1-7.5-7c0-4,3-7,7.6-7s7.4,3,7.5,7
          C42.2,34.8,39.2,37.9,34.6,37.9z M89.6,83.7H76.2V62.2c0-5.4-1.9-9.1-6.8-9.1c-3.7,0-5.9,2.5-6.9,4.9c-0.4,0.9-0.4,2.1-0.4,3.3v22.5
          H48.7c0,0,0.2-36.5,0-40.3h13.4v5.7c1.8-2.7,5-6.7,12.1-6.7c8.8,0,15.4,5.8,15.4,18.1V83.7z"
                          ></path>
                        </svg>
                      </span>
                    </a>
                    <a
                      class="u-social-url"
                      title="twitter"
                      target="_blank"
                      href="https://twitter.com/name"
                    >
                      <span class="u-icon u-icon-circle u-social-icon u-social-twitter u-text-black u-icon-8">
                        <svg
                          class="u-svg-link"
                          preserveAspectRatio="xMidYMin slice"
                          viewBox="0 0 112 112"
                        >
                          <use
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xlinkHref="#svg-6c19"
                          ></use>
                        </svg>
                        <svg
                          class="u-svg-content"
                          viewBox="0 0 112 112"
                          x="0"
                          y="0"
                          id="svg-6c19"
                        >
                          <circle
                            fill="currentColor"
                            class="st0"
                            cx="56.1"
                            cy="56.1"
                            r="55"
                          ></circle>
                          <path
                            fill="#FFFFFF"
                            d="M83.8,47.3c0,0.6,0,1.2,0,1.7c0,17.7-13.5,38.2-38.2,38.2C38,87.2,31,85,25,81.2c1,0.1,2.1,0.2,3.2,0.2
c6.3,0,12.1-2.1,16.7-5.7c-5.9-0.1-10.8-4-12.5-9.3c0.8,0.2,1.7,0.2,2.5,0.2c1.2,0,2.4-0.2,3.5-0.5c-6.1-1.2-10.8-6.7-10.8-13.1
c0-0.1,0-0.1,0-0.2c1.8,1,3.9,1.6,6.1,1.7c-3.6-2.4-6-6.5-6-11.2c0-2.5,0.7-4.8,1.8-6.7c6.6,8.1,16.5,13.5,27.6,14
c-0.2-1-0.3-2-0.3-3.1c0-7.4,6-13.4,13.4-13.4c3.9,0,7.3,1.6,9.8,4.2c3.1-0.6,5.9-1.7,8.5-3.3c-1,3.1-3.1,5.8-5.9,7.4
c2.7-0.3,5.3-1,7.7-2.1C88.7,43,86.4,45.4,83.8,47.3z"
                          ></path>
                        </svg>
                      </span>
                    </a>
                    <a
                      class="u-social-url"
                      target="_blank"
                      data-type="Github"
                      title="Github"
                      href="https://github.com/tanktejas"
                    >
                      <span class="u-icon u-social-github u-social-icon u-text-black u-icon-9">
                        <svg
                          class="u-svg-link"
                          preserveAspectRatio="xMidYMin slice"
                          viewBox="0 0 112 112"
                        >
                          <use
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xlinkHref="#svg-f041"
                          ></use>
                        </svg>
                        <svg
                          class="u-svg-content"
                          viewBox="0 0 112 112"
                          x="0"
                          y="0"
                          id="svg-f041"
                        >
                          <circle
                            fill="currentColor"
                            cx="56.1"
                            cy="56.1"
                            r="55"
                          ></circle>
                          <path
                            fill="#FFFFFF"
                            d="M88,51.3c0-5.5-1.9-10.2-5.3-13.7c0.6-1.3,2.3-6.5-0.5-13.5c0,0-4.2-1.4-14,5.3c-4.1-1.1-8.4-1.7-12.7-1.8
  c-4.3,0-8.7,0.6-12.7,1.8c-9.7-6.6-14-5.3-14-5.3c-2.8,7-1,12.2-0.5,13.5C25,41.2,23,45.7,23,51.3c0,19.6,11.9,23.9,23.3,25.2
  c-1.5,1.3-2.8,3.5-3.2,6.8c-3,1.3-10.2,3.6-14.9-4.3c0,0-2.7-4.9-7.8-5.3c0,0-5-0.1-0.4,3.1c0,0,3.3,1.6,5.6,7.5c0,0,3,9.1,17.2,6
  c0,4.3,0.1,8.3,0.1,9.5h25.2c0-1.7,0.1-7.2,0.1-14c0-4.7-1.7-7.9-3.4-9.4C76,75.2,88,70.9,88,51.3z"
                          ></path>
                        </svg>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              
              <div class="u-align-left u-container-list-item u-radius-20 u-repeater-item u-shape-round u-white">
                <div class="u-container-layout u-similar-container u-container-layout-5">
                  <img
                    alt=""
                    class="u-expanded-width u-image u-image-round u-radius-20 u-image-5"
                    data-image-width="640"
                    data-image-height="640"
                    src="images/contact.jpg"
                  />
                  <p class="u-text u-text-grey-30 u-text-15">
                    GRAPHICS DESIGNER&nbsp;
                  </p>
                  <h3 class="u-text u-text-default u-text-16">
                    Manav Joshi
                  </h3>
                  <p class="u-text u-text-body-color u-text-17">
                    Manav is the heart of scholars because of his UI/UX Design's
                    we can attract more user.
                  </p>
                  <div class="u-align-left u-social-icons u-spacing-30 u-social-icons-5">
                    <a
                      class="u-social-url"
                      target="_blank"
                      data-type="LinkedIn"
                      title="LinkedIn"
                      href="https://www.linkedin.com/in/vivek-baldaniya-8a859a1b2/"
                    >
                      <span class="u-icon u-social-icon u-social-linkedin u-text-black u-icon-13">
                        <svg
                          class="u-svg-link"
                          preserveAspectRatio="xMidYMin slice"
                          viewBox="0 0 112 112"
                        >
                          <use
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xlinkHref="#svg-fa50"
                          ></use>
                        </svg>
                        <svg
                          class="u-svg-content"
                          viewBox="0 0 112 112"
                          x="0"
                          y="0"
                          id="svg-fa50"
                        >
                          <circle
                            fill="currentColor"
                            cx="56.1"
                            cy="56.1"
                            r="55"
                          ></circle>
                          <path
                            fill="#FFFFFF"
                            d="M41.3,83.7H27.9V43.4h13.4V83.7z M34.6,37.9L34.6,37.9c-4.6,0-7.5-3.1-7.5-7c0-4,3-7,7.6-7s7.4,3,7.5,7
          C42.2,34.8,39.2,37.9,34.6,37.9z M89.6,83.7H76.2V62.2c0-5.4-1.9-9.1-6.8-9.1c-3.7,0-5.9,2.5-6.9,4.9c-0.4,0.9-0.4,2.1-0.4,3.3v22.5
          H48.7c0,0,0.2-36.5,0-40.3h13.4v5.7c1.8-2.7,5-6.7,12.1-6.7c8.8,0,15.4,5.8,15.4,18.1V83.7z"
                          ></path>
                        </svg>
                      </span>
                    </a>
                    <a
                      class="u-social-url"
                      title="twitter"
                      target="_blank"
                      href="https://twitter.com/name"
                    >
                      <span class="u-icon u-icon-circle u-social-icon u-social-twitter u-text-black u-icon-14">
                        <svg
                          class="u-svg-link"
                          preserveAspectRatio="xMidYMin slice"
                          viewBox="0 0 112 112"
                        >
                          <use
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xlinkHref="#svg-6c19"
                          ></use>
                        </svg>
                        <svg
                          class="u-svg-content"
                          viewBox="0 0 112 112"
                          x="0"
                          y="0"
                          id="svg-6c19"
                        >
                          <circle
                            fill="currentColor"
                            class="st0"
                            cx="56.1"
                            cy="56.1"
                            r="55"
                          ></circle>
                          <path
                            fill="#FFFFFF"
                            d="M83.8,47.3c0,0.6,0,1.2,0,1.7c0,17.7-13.5,38.2-38.2,38.2C38,87.2,31,85,25,81.2c1,0.1,2.1,0.2,3.2,0.2
c6.3,0,12.1-2.1,16.7-5.7c-5.9-0.1-10.8-4-12.5-9.3c0.8,0.2,1.7,0.2,2.5,0.2c1.2,0,2.4-0.2,3.5-0.5c-6.1-1.2-10.8-6.7-10.8-13.1
c0-0.1,0-0.1,0-0.2c1.8,1,3.9,1.6,6.1,1.7c-3.6-2.4-6-6.5-6-11.2c0-2.5,0.7-4.8,1.8-6.7c6.6,8.1,16.5,13.5,27.6,14
c-0.2-1-0.3-2-0.3-3.1c0-7.4,6-13.4,13.4-13.4c3.9,0,7.3,1.6,9.8,4.2c3.1-0.6,5.9-1.7,8.5-3.3c-1,3.1-3.1,5.8-5.9,7.4
c2.7-0.3,5.3-1,7.7-2.1C88.7,43,86.4,45.4,83.8,47.3z"
                          ></path>
                        </svg>
                      </span>
                    </a>
                    <a
                      class="u-social-url"
                      target="_blank"
                      data-type="Github"
                      title="Github"
                      href="https://github.com/Vivek-Baldaniya"
                    >
                      <span class="u-icon u-social-github u-social-icon u-text-black u-icon-15">
                        <svg
                          class="u-svg-link"
                          preserveAspectRatio="xMidYMin slice"
                          viewBox="0 0 112 112"
                        >
                          <use
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xlinkHref="#svg-f041"
                          ></use>
                        </svg>
                        <svg
                          class="u-svg-content"
                          viewBox="0 0 112 112"
                          x="0"
                          y="0"
                          id="svg-f041"
                        >
                          <circle
                            fill="currentColor"
                            cx="56.1"
                            cy="56.1"
                            r="55"
                          ></circle>
                          <path
                            fill="#FFFFFF"
                            d="M88,51.3c0-5.5-1.9-10.2-5.3-13.7c0.6-1.3,2.3-6.5-0.5-13.5c0,0-4.2-1.4-14,5.3c-4.1-1.1-8.4-1.7-12.7-1.8
  c-4.3,0-8.7,0.6-12.7,1.8c-9.7-6.6-14-5.3-14-5.3c-2.8,7-1,12.2-0.5,13.5C25,41.2,23,45.7,23,51.3c0,19.6,11.9,23.9,23.3,25.2
  c-1.5,1.3-2.8,3.5-3.2,6.8c-3,1.3-10.2,3.6-14.9-4.3c0,0-2.7-4.9-7.8-5.3c0,0-5-0.1-0.4,3.1c0,0,3.3,1.6,5.6,7.5c0,0,3,9.1,17.2,6
  c0,4.3,0.1,8.3,0.1,9.5h25.2c0-1.7,0.1-7.2,0.1-14c0-4.7-1.7-7.9-3.4-9.4C76,75.2,88,70.9,88,51.3z"
                          ></path>
                        </svg>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Team;
